import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ChangePassword from '../pages/ChangePassword'
import Container from '@material-ui/core/Container'


const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(4)
  }
}))


export default function UserSettings(){
  const c = useStyles()

  return (
    <Container maxWidth='xs' className={c.container}>
      <ChangePassword/>
    </Container>
  )
}